import { t } from 'i18next';
import * as yup from 'yup';

import { FormAnswers } from '../../../interfaces';
import { emailRegexp, nameSurnameRegexp, polishPhoneRegexp } from '../../../regexps';

export const schema: yup.ObjectSchema<FormAnswers> = yup.object({
  supervisorData: yup.object({
    name: yup
      .string()
      .required(t('competence.app.eventFormDrawer.form.required'))
      .matches(nameSurnameRegexp, t('competence.app.eventFormDrawer.form.invalidName'))
      .min(2, t('competence.app.eventFormDrawer.form.invalidName'))
      .max(50, t('competence.app.eventFormDrawer.form.invalidName')),
    surname: yup
      .string()
      .required(t('competence.app.eventFormDrawer.form.required'))
      .matches(nameSurnameRegexp, t('competence.app.eventFormDrawer.form.invalidSurname'))
      .min(2, t('competence.app.eventFormDrawer.form.invalidSurname'))
      .max(128, t('competence.app.eventFormDrawer.form.invalidSurname')),
    email: yup
      .string()
      .required(t('competence.app.eventFormDrawer.form.required'))
      .matches(emailRegexp, t('competence.app.eventFormDrawer.form.invalidEmail'))
      .max(128, t('competence.app.eventFormDrawer.form.invalidEmail')),
  }).required(),
  userData: yup.object({
    phone: yup
      .string()
      .required(t('competence.app.eventFormDrawer.form.required'))
      .matches(polishPhoneRegexp, t('competence.app.eventFormDrawer.form.invalidPhone')),
    addons: yup.object({
      withAccommodation: yup.boolean().default(false),
      withParking: yup.boolean().default(false),
      withVege: yup.boolean().default(false),
      withDinner: yup.boolean().default(false),
    }).required(),
  }).required(),
}).required();
